"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkA7CW6FVUcjs = require('./chunk-A7CW6FVU.cjs');


var _chunkJRI7V75Bcjs = require('./chunk-JRI7V75B.cjs');


var _chunk3SFKQNZAcjs = require('./chunk-3SFKQNZA.cjs');


var _chunkR5F56AVKcjs = require('./chunk-R5F56AVK.cjs');


var _chunk7Y3FNKTFcjs = require('./chunk-7Y3FNKTF.cjs');

// src/contracts/dex/v2_2/index.ts
var DEX = {
  Router: _chunkA7CW6FVUcjs.RouterV2_2,
  Pool: _chunkJRI7V75Bcjs.PoolV2_2,
  LpAccount: _chunk3SFKQNZAcjs.LpAccountV2_2,
  Vault: _chunkR5F56AVKcjs.VaultV2_2,
  pTON: _chunk7Y3FNKTFcjs.PtonV2_1
};



exports.DEX = DEX;
//# sourceMappingURL=chunk-XQPAMLNG.cjs.map